module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Pending result")]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for completing all of the steps in the application,interview,and training stages,this is the final total teacher profile check performed to ensure the requirements and qualifications of new teachers meet the overall standards prior to being added to the system. You will receive a feedback from our team within 3 business days.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("HAWO Recruitment Team")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ec4e08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/online_pending.vue
// module id = 816
// module chunks = 1